export default function getUrl(path) {
    return process.env.VUE_APP_API_URL + path;
}
